const journalsData = [
  {
    id: 1,
    serialNumber: "001",
    title: "Directory of Open Access Journals (DOAJ)",
    description: "Comprehensive directory providing access to high-quality, peer-reviewed open access journals across all disciplines.",
    link: "https://doaj.org",
    category: "Open Access"
  },
  {
    id: 2,
    serialNumber: "002",
    title: "Indian Academy of Sciences (IAS)",
    description: "Research journals published by the Indian Academy of Sciences covering various scientific disciplines.",
    link: "https://www.ias.ac.in",
    category: "Science"
  },
  {
    id: 3,
    serialNumber: "003",
    title: "Niscair Full Text Journals",
    description: "Full-text access to journals published by National Institute of Science Communication and Information Resources.",
    link: "https://www.niscair.res.in",
    category: "Science"
  },
  {
    id: 4,
    serialNumber: "004",
    title: "Bentham 175 Open Access Journals",
    description: "Collection of 175 open access journals published by Bentham Science covering pharmaceutical, medical and engineering sciences.",
    link: "https://benthamopen.com",
    category: "Open Access"
  },
  {
    id: 5,
    serialNumber: "005",
    title: "High Wire Press - Earth's largest free-full science archives (journals) 320 journals",
    description: "Archive of 320 scientific journals providing free full-text access to research articles and publications.",
    link: "https://www.highwirepress.com",
    category: "Science"
  },
  {
    id: 6,
    serialNumber: "006",
    title: "Institute of Physics electronic journals (IOP) 60 e-journals",
    description: "Collection of 60 electronic journals published by Institute of Physics covering physics and related sciences.",
    link: "https://iopscience.iop.org",
    category: "Physics"
  },
  {
    id: 7,
    serialNumber: "007",
    title: "Journal of the Indian Institute of Science",
    description: "Multidisciplinary research journal published by the Indian Institute of Science, Bangalore.",
    link: "https://journal.iisc.ernet.in",
    category: "Science"
  },
  {
    id: 8,
    serialNumber: "008",
    title: "Down to Earth",
    description: "Science and environment magazine focusing on environmental issues, climate change, and sustainable development.",
    link: "https://www.downtoearth.org.in",
    category: "Environmental Sciences"
  },
  {
    id: 9,
    serialNumber: "009",
    title: "Indian National Science Academy journals (INSA)",
    description: "Research journals published by the Indian National Science Academy covering various scientific disciplines.",
    link: "https://www.insaindia.res.in",
    category: "Science"
  },
  {
    id: 10,
    serialNumber: "010",
    title: "Indian Journals",
    description: "Collection of academic and research journals published in India across various disciplines.",
    link: "https://www.indianjournals.com",
    category: "Academic"
  },
  {
    id: 11,
    serialNumber: "011",
    title: "Iete Journals (Institution Of Electronics And Telecommunication Engineers.)",
    description: "Technical journals published by the Institution of Electronics and Telecommunication Engineers (IETE).",
    link: "https://www.iete.org",
    category: "Engineering"
  },
  {
    id: 12,
    serialNumber: "012",
    title: "Open j-Gate 4805 Open Access Journals",
    description: "Gateway providing access to 4805 open access journals across multiple disciplines and publishers.",
    link: "https://www.openj-gate.com",
    category: "Open Access"
  },
  {
    id: 13,
    serialNumber: "013",
    title: "Open Access Journals Search Engine",
    description: "Search engine dedicated to finding and accessing open access academic journals and research publications.",
    link: "https://www.oajse.com",
    category: "Open Access"
  },
  {
    id: 14,
    serialNumber: "014",
    title: "Medknow Publications Journals",
    description: "Medical and health science journals published by Medknow Publications covering various medical specialties.",
    link: "https://www.medknow.com",
    category: "Medical Sciences"
  },
  {
    id: 15,
    serialNumber: "015",
    title: "49 Full Open Access STM Journals",
    description: "Collection of 49 full open access journals in Science, Technology, and Medicine (STM) fields.",
    link: "https://www.stm-journals.org",
    category: "STM"
  },
  {
    id: 16,
    serialNumber: "016",
    title: "National Science Digital Library (NSDL) - Digital Learning",
    description: "Digital library providing access to science, technology, engineering and mathematics educational resources.",
    link: "https://nsdl.niscair.res.in",
    category: "Digital Library"
  },
  {
    id: 17,
    serialNumber: "017",
    title: "Directory of Open Access Repositories",
    description: "Directory providing access to open access repositories containing research papers, theses, and academic publications.",
    link: "https://v2.sherpa.ac.uk/opendoar",
    category: "Open Access"
  }
];

export default journalsData;